<template>
  <div>
    <Heading :onClick="goToSection" />
    <section>
      <div class="Clickable-Headers">
        <div @click="goToSection(HeaderName.ActivateCharger)">
          <h3>{{ $t('charge_help.index_1') }}</h3>
          <div class="circle">1</div>
        </div>
        <div @click="goToSection(HeaderName.PluginCar)">
          <h3>{{ $t('charge_help.index_2') }}</h3>
          <div class="circle">2</div>
        </div>
        <div @click="goToSection(HeaderName.Charge)">
          <h3>{{ $t('charge_help.index_3') }}</h3>
          <div class="circle">3</div>
        </div>
        <div @click="goToSection(HeaderName.FinishCharging)">
          <h3>{{ $t('charge_help.index_4') }}</h3>
          <div class="circle">4</div>
        </div>
        <div class="line" />
      </div>
    </section>
    <div :ref="HeaderName.ActivateCharger">
      <Explainer
        :title="$t('charge_help.section1_title')"
        :text="matchEntities(['POLAND']) ? $t('charge_help.section2_text') : ''"
      >
        <PlugCar
          v-if="matchEntities(['POLAND'])"
          :toggleVideoPlayer="toggleVideoPlayer"
        />
        <ActivateCharger v-else />
      </Explainer>
    </div>
    <div :ref="HeaderName.PluginCar">
      <Explainer
        :title="$t('charge_help.section2_title')"
        :text="
          !matchEntities(['POLAND']) ? $t('charge_help.section2_text') : ''
        "
        styles="margin-bottom: 0px"
      >
        <ActivateCharger v-if="matchEntities(['POLAND'])" />
        <PlugCar :toggleVideoPlayer="toggleVideoPlayer" v-else />
      </Explainer>
    </div>
    <div :ref="HeaderName.Charge">
      <Explainer
        :title="$t('charge_help.section3_title')"
        :text="$t('charge_help.section3_text')"
      >
        <div style="max-width: 190px; margin: 0 auto;">
          <Images
            :data="{
              webp_src: `assets/homePage/iphone-charging-${entity}-${locale}.webp`,
              png_src: `assets/homePage/iphone-charging-${entity}-${locale}.png`,
              alt:
                'A screenshot of the Qwello App with a detailed list of a charging session',
            }"
          />
        </div>
      </Explainer>
    </div>
    <div>
      <Explainer
        :title="$t('charge_help.section4_title')"
        :list="formatList($t('charge_help.section4_text'))"
      >
        <div class="video-parent" :entity="entity">
          <div
            v-if="!matchEntities(['POLAND'])"
            @click="toggleVideoPlayer('assets/help/disconnect_intcable.mp4')"
            class="video-wrapper"
          >
            <p :ref="HeaderName.FinishCharging">
              {{ $t('charge_help.section2_video1') }}
            </p>
            <div
              class="video-border"
              style="background-image: var(--integrated-start-thumbnail);"
            >
              <div class="play-circle"></div>
            </div>
          </div>
          <div
            @click="toggleVideoPlayer('assets/help/disconnect_carcable.mp4')"
            class="video-wrapper"
          >
            <p v-show="!matchEntities(['POLAND'])">
              {{ $t('charge_help.section2_video2') }}
            </p>
            <div
              class="video-border"
              style="background-image: var(--car-cable-thumbnail);"
            >
              <div class="play-circle"></div>
            </div>
          </div>
        </div>
        <div class="PricingWrapper">
          <h4 :ref="HeaderName.Tariff" class="PricingHeader">
            {{ $t('charge_help.pricing_header') }}
          </h4>
          <Tariffs :chargeHelp="true" />
        </div>
        <section>
          <h4 class="h4">
            <Logo-Image
              :data="{
                sources: {
                  webp: 'assets/help/invoice-ic.svg',
                  png: 'assets/help/invoice-ic.svg',
                },
                alt: 'An image of an invoice',
              }"
            />
            <p>
              {{ $t('charge_help.section5_title') }}
            </p>
          </h4>
          <h5 class="h5">
            {{ $t('charge_help.section5.card1_title') }}
            <span class="highlighted-text">
              {{ $t('charge_help.section5.card1_title_highlight') }}
            </span>
          </h5>
          <p>
            {{ $t('charge_help.section5.card1_text') }}
          </p>
          <div v-if="!matchEntities(['POLAND'])">
            <h5 :ref="HeaderName.Invoice" class="h5">
              {{ $t('charge_help.section5.card2_title') }}
              <span class="highlighted-text">
                {{ $t('charge_help.section5.card2_title_highlight') }}
              </span>
              {{ $t('charge_help.section5.card2_title_end') }}
            </h5>
            <p>
              {{ $t('charge_help.section5.card2_text') }}
            </p>
          </div>
          <h5 class="h5">
            {{ $t('charge_help.section5.card3_title') }}
            <span class="highlighted-text">
              {{ $t('charge_help.section5.card3_title_highlight') }}
            </span>
          </h5>
          <p>
            {{ $t('charge_help.section5.card3_text') }}
          </p>
          <div class="questionaire">
            <div class="default">
              <p class="questionaire-title">
                {{ text[state] }}
              </p>
              <div class="buttons">
                <button
                  class="button"
                  @click="
                    () => {
                      send('how_to_feedback', { title: 'yes' });
                      state = stateTypes.yes;
                    }
                  "
                  v-if="['default', 'yes'].includes(state)"
                >
                  <logo-image
                    :data="{
                      sources: {
                        webp: 'assets/help/yes-ic.svg',
                        png: 'assets/help/yes-ic.svg',
                      },
                      alt: 'A green check marker',
                    }"
                  />
                </button>
                <button
                  v-if="state === stateTypes.default"
                  class="button"
                  @click="
                    () => {
                      send('how_to_feedback', { title: 'no' });
                      state = stateTypes.no;
                    }
                  "
                >
                  <logo-image
                    :data="{
                      sources: {
                        webp: 'assets/help/no-ic.svg',
                        png: 'assets/help/no-ic.svg',
                      },
                      alt: 'A red cross marker',
                    }"
                  />
                </button>
                <router-link
                  :to="{ path: 'faq' }"
                  class="help-button"
                  v-if="state === stateTypes.no"
                >
                  {{ $t('charge_help.feedback_response2_button1') }}
                </router-link>
                <a
                  v-if="state === stateTypes.no"
                  class="help-button"
                  :href="`tel:${$t('contact.support_phone')}`"
                  >{{ $t('charge_help.feedback_response2_button2') }}</a
                >
              </div>
            </div>
          </div>
        </section>
      </Explainer>
    </div>
    <VideoViewer
      :videoSrc="videoSrc"
      :toggle="toggleVideoPlayer"
      v-if="videoSrc"
    />
  </div>
</template>

<script>
import { sendAnalytics } from '@/shared/analytics';
import { LOCALSTORAGE_IDS } from '@/data/constants';
import { entity } from '../../../region.json';
import Heading from './Header.vue';
import Explainer from './Explainer.vue';
import ActivateCharger from './ActivateCharger.vue';
import PlugCar from './PlugCar.vue';
import LogoImage from './Logo.vue';
import VideoViewer from './VideoViewer.vue';
import Images from './Images.vue';
import matchEntities from '../../shared/entityHelpers';
import Tariffs from '../shared/Tariffs.vue';

export const HeaderName = {
  ActivateCharger: 0,
  PluginCar: 1,
  Charge: 2,
  FinishCharging: 3,
  Tariff: 4,
  Invoice: 5,
};

function formatList(string) {
  const lines = string.split('\n');
  const newLines = [];
  // eslint-disable-next-line
  for (const line of lines) {
    let temp = line.trim();
    temp = temp.split(' ');
    temp.shift();
    newLines.push(temp.join(' '));
  }
  return newLines;
}

export default {
  components: {
    Heading,
    Explainer,
    LogoImage,
    VideoViewer,
    Images,
    ActivateCharger,
    PlugCar,
    Tariffs,
  },
  data() {
    return {
      HeaderName,
      videoSrc: null,
      entity,
      locale: this.$i18n.locale,
      state: 'default',
      analyticsPermitted: false,
      text: {
        default: this.$i18n.t('charge_help.feedback_title'),
        yes: this.$i18n.t('charge_help.feedback_response1_text'),
        no: this.$i18n.t('charge_help.feedback_response2_text'),
      },
      stateTypes: {
        no: 'no',
        yes: 'yes',
        default: 'default',
      },
    };
  },
  methods: {
    formatList,
    matchEntities,
    goToSection(index) {
      const element = this.$refs[index];
      if (!element) return;
      // Scroll to center if it's the first element, otherwise the navbar will cut it off from view.
      if (index === HeaderName.ActivateCharger) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      } else {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'start',
        });
      }
    },
    toggleVideoPlayer(videoSrc) {
      this.videoSrc = videoSrc;
    },

    checkLocalStorage() {
      const decision = window.localStorage.getItem(
        LOCALSTORAGE_IDS.USER_COOKIES
      );

      if (decision !== null) {
        const parsedDecision = JSON.parse(decision);

        if (parsedDecision) {
          this.analyticsPermitted = true;
        }
      }
    },
    send(name, opts) {
      if (this.analyticsPermitted) {
        sendAnalytics(name, opts);
      }
    },
  },
  mounted() {
    this.checkLocalStorage();
  },
};
</script>

<style scoped>
.Clickable-Headers {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: flex-end;
  margin-top: 4em;
  margin-bottom: 80px;
}
.Clickable-Headers h3 {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  max-width: 10ch;
  color: #2b4047;
}
.Clickable-Headers > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 2px;
  grid-row: 1;
}
.Clickable-Headers > div:nth-of-type(1) {
  grid-column: 1;
}
.Clickable-Headers > div:nth-of-type(2) {
  grid-column: 2;
}
.Clickable-Headers > div:nth-of-type(3) {
  grid-column: 3;
}
.Clickable-Headers > div:nth-of-type(4) {
  grid-column: 4;
}
.circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #ffdf22;
  display: grid;
  place-items: center;
  font-weight: bold;
  color: #2b4047;
}
.line {
  height: 2px;
  background: #ffdf22;
  width: 80%;
  justify-self: center;
  grid-column: 1 / -1;
  grid-row: 1;
  margin-bottom: 12px !important;
  z-index: -1;
}
.video-parent {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
}
.video-parent[entity='POLAND'] {
  grid-template-columns: 1fr;
}
.video-wrapper {
  display: grid;
  grid-template-rows: auto 1fr;
  --integrated-start-thumbnail: url(~@/assets/help/integrated-cable-start.svg);
  --car-cable-thumbnail: url(~@/assets/help/car-cable-img.svg);
  --integrated-end-thumbnail: url(~@/assets/help/integrated-cable-end.svg);
}
.video-wrapper p {
  font-weight: bold;
  color: #2b4047;
  margin: 0 0 10px 0;
}
.video-border {
  grid-row: 2;
  grid-column: 1;
  height: 190px;
  align-self: flex-start;
  padding: 0 5px;
  border-radius: 10px;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 95%;
  margin-bottom: 100px;
}
.video-border > * {
  grid-area: 1 / 1;
}
.play-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 52px;
  height: 52px;
  background: url(~@/assets/help/play-button.svg);
  background-repeat: no-repeat;
  object-fit: cover;
  object-position: left top;
}
.questionaire {
  background: #e4edef;
  width: 300px;
  min-height: 112px;
  margin: 0 auto;
  box-shadow: 0px 6px 16px #00000029;
  border-radius: 8px;
}
.default {
  display: grid;
  grid-template-rows: 1fr 1fr;
}
.questionaire-title {
  margin: 10px 0 0 0;
  font-size: 14px;
}
.buttons {
  grid-row: 2;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  height: 50px;
}
.h4 {
  font-family: 'Foco';
}
.h4,
.h5 {
  color: #41565d;
  font-weight: bold;
}

.h4 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
}
.h4 p {
  margin-left: 0.4em;
  margin-bottom: 0;
  font-size: 20px;
  text-align: left;
}
.h5 {
  text-align: center;
  font-size: 14px;
  margin-bottom: 8px;
}
.yes {
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-rows: 1fr 1fr;
}
.yes p {
  margin: 0;
}
.help-button {
  margin-top: 0.5em;
  color: #2b4047;
  background: #ffdf22;
  border-radius: 22px;
  box-shadow: 0px 3px 6px #00000029;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100px;
  height: 32px;
  padding: 0 10px;
}
.help-button:nth-child(2n) {
  margin-left: 1em;
}
button {
  outline: none;
}

.highlighted-text {
  --yellow: #ffdf22;
  position: relative;
  height: min-content;
  font-weight: bold;
  width: max-content;
  margin-bottom: 1em;
}
.highlighted-text::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 10px;
  left: 0px;
  top: 50%;
  z-index: -1;
  background: var(--yellow);
}
.PricingWrapper {
  display: grid;
  margin-top: 20px;
}
.PricingHeader {
  margin: 1em auto;
  grid-column: 1/-1;
  color: #2b4047;
  text-align: center;
  font-family: 'Foco';
  font-size: 35px;
  line-height: normal;
}
.Pricing {
  border-radius: 8px;
  box-shadow: 0px 7px 20px #0033;
  color: var(--pricing-color);
  padding: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  --cost-f-size: 16px;
  --pricing-f-size: 20px;
  --pricing-terms-f-size: 10px;
  min-height: 250px;
}
.Pricing[data-type='day'] {
  grid-column: 1;
  --pricing-color-light: #a1b1b5;
  color: #2b4047;
}
.Pricing[data-type='night'] {
  grid-column: 3;
  background: #2b4047;
  --pricing-color: #ffffff;
  --pricing-color-light: #a1b1b5;
}
.Pricing-image {
  margin: 0 auto;
  display: block;
  width: 45px;
  height: 45px;
}
.Pricing-title {
  color: inherit;
  font-size: var(--pricing-f-size);
  font-family: 'Foco';
  font-weight: bold;
  margin-top: 12px;
}
.Pricing-time,
.Pricing-terms {
  font-size: 14px;
  color: var(--pricing-color-light);
}
.Pricing-time {
  margin-bottom: 22px;
}
.Pricing-terms {
  margin-bottom: 0px;
}
.Pricing-cost {
  font-size: var(--cost-f-size);
  font-weight: inherit;
  color: inherit;
  margin-bottom: var(--pricing-terms-f-size);
  display: grid;
  grid-template-columns: 25px auto;
}
.Pricing-cost-image {
  max-width: 19px !important;
  max-height: 19px !important;
  min-height: 19px !important;
  align-self: center;
}
.Terms {
  font-size: var(--terms-f-size);
  color: #a1b1b5;
  grid-column: 1 / -1;
  margin-bottom: 10px;
  text-align: start;
}
@media (min-width: 400px) {
  .PricingWrapper {
    --terms-f-size: 14px;
    --pricing-grid-columns: 1fr 16px 1fr;
  }
  .Pricing {
    --cost-f-size: 20px;
    --pricing-f-size: 24px;
    --pricing-terms-f-size: 12px;
  }
}
</style>
